const LEGAL_PAGE_DEFINITIONS_INTERNAL = [
  {
    kind: 'structured',
    slug: 'impressum',
    path: '/impressum',
    titleKey: 'legal.pages.impressum',
    mode: 'all',
    tocMode: 'none',
    sourceFile: 'impressum',
  },
  {
    kind: 'structured',
    slug: 'privacy',
    path: '/privacy',
    titleKey: 'legal.pages.privacy',
    mode: 'all',
    tocMode: 'auto',
    sourceFile: 'privacy',
  },
  {
    kind: 'markdown',
    slug: 'cookies',
    path: '/cookies',
    titleKey: 'legal.pages.cookies',
    mode: 'all',
    tocMode: 'always',
    sourceFile: 'cookies',
  },
  {
    kind: 'markdown',
    slug: 'terms',
    path: '/terms',
    titleKey: 'legal.pages.terms',
    mode: 'full-only',
    tocMode: 'always',
    sourceFile: 'terms',
  },
  {
    kind: 'markdown',
    slug: 'dpa',
    path: '/dpa',
    titleKey: 'legal.pages.dpa',
    mode: 'full-only',
    tocMode: 'always',
    sourceFile: 'dpa',
  },
  {
    kind: 'markdown',
    slug: 'subprocessors',
    path: '/subprocessors',
    titleKey: 'legal.pages.subprocessors',
    mode: 'full-only',
    tocMode: 'always',
    sourceFile: 'subprocessors',
  },
  {
    kind: 'markdown',
    slug: 'security',
    path: '/security',
    titleKey: 'legal.pages.security',
    mode: 'full-only',
    tocMode: 'always',
    sourceFile: 'security',
  },
  {
    kind: 'markdown',
    slug: 'refunds-and-cancellation',
    path: '/refunds-and-cancellation',
    titleKey: 'legal.pages.refundsAndCancellation',
    mode: 'full-only',
    tocMode: 'always',
    sourceFile: 'refunds-and-cancellation',
  },
  {
    kind: 'markdown',
    slug: 'withdrawal',
    path: '/withdrawal',
    titleKey: 'legal.pages.withdrawal',
    mode: 'full-only',
    tocMode: 'always',
    sourceFile: 'withdrawal',
  },
];

export const LEGAL_PAGE_DEFINITIONS = Object.freeze(
  LEGAL_PAGE_DEFINITIONS_INTERNAL.map((entry) => Object.freeze({ ...entry })),
);

export const PUBLIC_LEGAL_PAGE_SLUGS = Object.freeze(
  LEGAL_PAGE_DEFINITIONS.map((entry) => entry.slug),
);
